var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrawer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    fill: "#999999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M0,30.5C0,31.327,0.673,32,1.5,32h29c0.827,0,1.5-0.673,1.5-1.5v-8c0-0.386-0.15-0.734-0.39-1 c0.24-0.266,0.39-0.614,0.39-1v-8c0-0.386-0.15-0.734-0.39-1c0.24-0.266,0.39-0.614,0.39-1v-9C32,0.673,31.327,0,30.5,0h-29 C0.673,0,0,0.673,0,1.5v9c0,0.386,0.15,0.734,0.39,1C0.15,11.766,0,12.114,0,12.5v8c0,0.386,0.15,0.734,0.39,1 C0.15,21.766,0,22.114,0,22.5V30.5z M31,30.5c0,0.276-0.224,0.5-0.5,0.5h-29C1.224,31,1,30.776,1,30.5v-8C1,22.224,1.224,22,1.5,22 h29c0.276,0,0.5,0.224,0.5,0.5V30.5z M1,20.5v-8C1,12.224,1.224,12,1.5,12h29c0.276,0,0.5,0.224,0.5,0.5v8 c0,0.276-0.224,0.5-0.5,0.5h-29C1.224,21,1,20.776,1,20.5z M1,1.5C1,1.224,1.224,1,1.5,1h29C30.776,1,31,1.224,31,1.5v9 c0,0.276-0.224,0.5-0.5,0.5h-29C1.224,11,1,10.776,1,10.5V1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M13,6h6c0.276,0,0.5-0.224,0.5-0.5S19.276,5,19,5h-6c-0.276,0-0.5,0.224-0.5,0.5S12.724,6,13,6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M19,15h-6c-0.276,0-0.5,0.224-0.5,0.5S12.724,16,13,16h6c0.276,0,0.5-0.224,0.5-0.5S19.276,15,19,15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M19,25h-6c-0.276,0-0.5,0.224-0.5,0.5S12.724,26,13,26h6c0.276,0,0.5-0.224,0.5-0.5S19.276,25,19,25z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawer);
export default __webpack_public_path__ + "static/media/drawer.4d0b434a9f3b30904628f43205a2ade5.svg";
export { ForwardRef as ReactComponent };